import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { boxStyles } from '../Box/styles.js';
import { baseButtonStyles } from '../Button/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';

var iconButton = /*#__PURE__*/styled.button.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__iconButton",
  componentId: "sc-his16h-0"
})(["display:inline-flex;align-items:center;justify-content:center;height:", ";width:", ";border-radius:", ";", " ", ";", ";"], function (props) {
  return typeof props.$size === 'string' ? props.$size : px2rem(props.$size);
}, function (props) {
  return typeof props.$size === 'string' ? props.$size : px2rem(props.$size);
}, function (p) {
  return p.theme.borders.radius;
}, function (props) {
  return props.$round ? css(["border-radius:", ";"], typeof props.$size === 'string' ? "calc(".concat(props.$size, " / 2)") : px2rem(props.$size / 2)) : null;
}, baseButtonStyles, boxStyles);

export { iconButton };
